import { render, staticRenderFns } from "./QnAVote.vue?vue&type=template&id=3808bec1"
import script from "./QnAVote.vue?vue&type=script&lang=js"
export * from "./QnAVote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports